/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2017, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'bi/content_apps/common/ContentListPageView',
	'bi/content_apps/common/ui/EllipsisLabel',
	'../../nls/StringResources',
	'./list_columns/LegacyAppsIcon',
	'./list_columns/LegacyAppsText',
	'bi/commons/utils/LegacyUtils',
	'lodash'
], function(ContentListPageView, EllipsisLabel, StringResources, LegacyAppsIcon, LegacyAppsText, LegacyUtils, _) {
	'use strict'; //NOSONAR: meant to be strict

	const LegacyPane = ContentListPageView.extend({

		renderContent() {
			const renderCLPromise = this.renderContentList({
				'columns': this._getColumnSpecification(),
				multiSelect: false
			});
			return renderCLPromise;
		},

		/**
			Defines the columns for the data table. The structure and properties of the definition come
			from the datatable API.
		**/
		_getColumnSpecification() {
			return [{
				'module': LegacyAppsIcon,
				'clickCallback': this._handleClick.bind(this)
			}, {
				'module': LegacyAppsText,
				'propertyName': 'label',
				'clickCallback': this._handleClick.bind(this)
			}, {
				'module': LegacyAppsIcon,
				'icon':'common-open-tab',
				'clickCallback': this._handleClick.bind(this)
			}];
		},

		_handleClick(evt = {}) {
			const rootSlideout = this.slideout.parent || this.slideout;
			if (evt.apps) {
				this.slideout.addChild({
					'position': 'left',
					'perspective': 'home',
					'content': {
						'module': 'ca_portal/features/legacyApps/LegacyPane',
						'id': 'LegacyPane',
						'parent': evt
					}
				});
			} else if (_.isFunction(evt.handler)){
				evt.glassContext = this.glassContext;
				evt.handler.call(LegacyUtils, evt);
				rootSlideout.remove();
			} else {
				LegacyUtils.legacyLaunch(this.glassContext,evt.type);
				rootSlideout.remove();
			}
		},

		contentbarItems() {
			return [{
				'name': 'nameLabel',
				'position': 'leading',
				'style': 'nameLabel',
				'module': EllipsisLabel,
				'label': this.parent ? this.parent.label : StringResources.get('companionApps')
			}];
		},

		getListControlOptions() {
			return {
				disableColumnHeaders: true,
				getJSONDataCallback: () => {
					const data = [];
					const apps = this.parent ? this.parent.apps : LegacyUtils.legacyApps;
					for (let type in apps) { //NOSONAR: meant to be inclusive
						const app = apps[type];
						if (LegacyUtils.canUseLegacyTool(this.glassContext, app)) {
							if (this.parent && !app.handler) {
								app.handler = this.parent.handler;
								app.handler.bind(this,app);
							}
							data[data.length] = {
								'type': type,
								'label': StringResources.get(type[0].toLowerCase() + type.substr(1)),
								'icon': app.icon,
								'apps': app.apps,
								'handler': app.handler
							};
						}
					}
					return Promise.resolve({
						'data': data
					});
				}
			};
		},

		setFocus() {
			this.$el.find('.nowrap.ellipsis_cell').first().focus();
		}
	});

	return LegacyPane;
});
